module.exports = __webpack_public_path__ + "img/1534027861.051d6115.jpg";